import Parallax	from "./circuits/parallax.js";

class AntifoamPump extends Parallax {
  constructor(p) {
    super(0x10, 1);
  }
  async update() {
    console.log( await this.command(`GetErrorFlags`));
    return true;
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      rpm: this.rpm,
      mlh: this.mlh,
      calibrationStatus: this.calibrationStatus,
      sumML: this.sumML
    });
  }
}

export default AntifoamPump;